import React from 'react';
import { Tooltip } from '@osmosis/tailwind-ui/components/tooltip/Tooltip';
import { Box } from '@osmosis/react-ui/components/Box';
import { Icon } from '@osmosis/react-ui/components/Icon';
import { IconButton } from '@osmosis/react-ui/components/IconButton';
import { faBan } from '@fortawesome/pro-regular-svg-icons/faBan';
import { useIntl } from 'react-intl';

type Props = {
  active: boolean;
  onClick: () => void;
};

/**
 * Button for repeating a flashcard.
 */
const DoNotRepeatButton = (props: Props) => {
  const { active, onClick } = props;
  const intl = useIntl();
  return (
    <>
      <Tooltip
        id="do-not-repeat-btn"
        content={
          active
            ? intl.formatMessage({
                defaultMessage: 'This flashcard does not repeat',
                id: 'flashcard.does_not_repeat',
              })
            : intl.formatMessage({
                defaultMessage: 'Do not repeat this flashcard',
                id: 'flashcard.do_not_repeat',
              })
        }
      />

      <Box data-tooltip-id="do-not-repeat-btn">
        <IconButton
          data-testid="do-not-repeat-btn"
          aria-label={intl.formatMessage({
            defaultMessage: 'Do not repeat this flashcard',
            id: 'flashcard.do_not_repeat',
          })}
          aria-pressed={active}
          variant="transparent"
          fontSize={16}
          color={active ? 'negative' : 'text'}
          icon={<Icon icon={faBan} />}
          onClick={onClick}
        />
      </Box>
    </>
  );
};

export default DoNotRepeatButton;
